module.exports = __webpack_public_path__ + "static/media/bg-settings.fe0cdd4e.svg";